/**
 * Pure Creative Decisions UI release-state resolver.
 *
 * The rollout flag is opt-out (enabled unless explicitly 'false'). The
 * independent rollback switch always wins so
 * an already-enabled build can be returned to the Reports surface without
 * changing any Creative Decisions product code.
 */
export function resolveCreativeDecisionsUiState(env = {}) {
  const rolloutRequested = normalizeFlag(env.VITE_CREATIVE_DECISIONS_UI_ENABLED) !== 'false';
  const rollbackActive = isRollbackActive(env.VITE_CREATIVE_DECISIONS_UI_ROLLBACK);

  return {
    enabled: rolloutRequested && !rollbackActive,
    rolloutRequested,
    rollbackActive,
    reason: !rolloutRequested
      ? 'rollout_disabled'
      : rollbackActive
        ? 'rollback_engaged'
        : 'enabled',
  };
}

function isRollbackActive(value) {
  if (value === undefined || value === null) return false;
  const normalized = normalizeFlag(value);
  if (!normalized) return false;
  // Fail safe for malformed non-empty values: only an explicit false clears
  // an operator-provided rollback setting.
  return normalized !== 'false';
}

function normalizeFlag(value) {
  return typeof value === 'string' ? value.trim().toLowerCase() : '';
}
